export default "images/bg3.jpg";